
  import { mapState, mapGetters } from 'vuex'
  import { FRONTEND_ERROR_CODES } from '~/utils/constants'
  export default {
    name: 'AddBankAccountInternational',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      data: {
        type: Object,
        default: () => {}
      }
    },
    data: () => ({
      formValid: false,
      formData: {
        bank_branch: '',
        bank_id: '',
        bank_account_number: ''
      },
      accountNo: '',
      supportedCurrencyList: [],
      bankOptionSelection: 1
    }),
    computed: {
      modal: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      },
      ...mapState({
        player: state => state.player.player,
        operationSetting: state => state.settings.operationSetting
      }),
      ...mapGetters({
        loading: 'themes/player-bank/loading',
        banks: 'banks/banks',
        bankAccount: 'themes/player-bank/bankAccount'
      }),
      formRule() {
        const playerAccountHolderNameRegex = /^[\p{L}\p{Mark}.\s]+$/u
        return {
          bank_id: [v => !!v || this.tr(this.FRONTEND_ERROR_CODES.bankIsRequired)],
          account_holder_name: [
            v => !!v || this.tr(this.FRONTEND_ERROR_CODES.bankAccountHolderNameIsRequired),
            v =>
              playerAccountHolderNameRegex.test(v) ||
              `${this.tr(this.FRONTEND_ERROR_CODES.accountHolderNameShouldBeAlphabetsAndDotsOnly)}`
          ],
          bank_account_number: [
            v => !!v || this.tr(this.FRONTEND_ERROR_CODES.accountNumberIsRequired),
            v =>
              /^[\d\s]+$/.test(v) ||
              this.tr(this.FRONTEND_ERROR_CODES.accountNumberShouldContainOnlyNumber)
          ],
          bank_name: [v => !!v || `${this.tr(FRONTEND_ERROR_CODES.bankNameIsRequired)}`]
        }
      }
    },
    watch: {
      data(value) {
        if (value?.id) {
          this.onDisplayEditModal(value?.id)
        }
      }
    },
    methods: {
      closeBankAccountDialog() {
        this.accountNo = ''
        this.$refs?.refBank?.reset()
        this.$emit('click')
      },
      doOperation() {
        if (this.accountNo) {
          this.updatePlayerBankAccount()
        } else {
          this.addPlayerBankAccount()
        }
      },
      async addPlayerBankAccount() {
        this.$refs?.refBank?.validate()
        if (!this.formValid) return
        if (this.bankOptionSelection === 2) {
          delete this.formData.bank_id
        } else {
          delete this.formData.bank_name
        }
        if (this.formData.bank_name) {
          this.formData.bank_currency = this.player.currency
        }
        if (this.player?.name) delete this.formData.name
        const result = await this.$store.dispatch(
          'themes/player-bank/doInsertPlayerBankAccount',
          this.formData
        )
        if (result) {
          this.$refs?.refBank?.reset()
          this.$toast.success(this.tl('addBankSuccessful'))
          this.closeBankAccountDialog()
          if (this.bankAccount?.player_bank_accounts?.length === 0)
            this.$store.dispatch('player/profile')
        }
      },
      async updatePlayerBankAccount() {
        this.$refs?.refBank?.validate()
        if (!this.formValid) return
        if (this.bankOptionSelection === 2) {
          delete this.formData.bank_id
        } else {
          delete this.formData.bank_name
        }
        if (this.player?.name) delete this.formData.account_holder_name
        const result = await this.$store.dispatch('themes/player-bank/doUpdatePlayerBankAccount', {
          form: { ...this.formData },
          accountId: this.accountNo
        })
        if (result) {
          // reset the bank account id, for modal purpose
          this.accountNo = null
          this.closeBankAccountDialog()
        }
      },
      onChangeBank(bankId) {
        // This function is for getting bank supported currency
        const bank = this.banks.find(el => el.id === bankId)
        const { supported_currency: supportedCurrency } = bank
        this.supportedCurrencyList = supportedCurrency

        if (this.supportedCurrencyList.length > 0) {
          this.formData.bank_currency = this.supportedCurrencyList[0]
        }
      },
      onAddBankAccount() {
        if (this.accountLimitExceeded) {
          this.$toast.error(this.tr(this.FRONTEND_ERROR_CODES.bankAccountLimitExceeded))
          return null
        }
        this.addBankAccountModel = true
      },
      onDisplayEditModal(id) {
        this.accountNo = id

        const getBankDetailById = this.bankAccount.player_bank_accounts.find(el => el.id === id)

        const {
          bank_account_number: bankAccountNumber,
          bank_id: bankId,
          bank_branch: bankBranch,
          currency
        } = getBankDetailById

        this.formData = {}
        this.formData.bank_currency = currency
        this.formData.bank_branch = bankBranch
        this.formData.bank_account_number = bankAccountNumber
        this.formData.account_holder_name = this.player.name
        if (bankId) {
          this.formData.bank_id = bankId
          this.bankOptionSelection = 1
        } else {
          this.formData.bank_name = getBankDetailById.player_bank_name
          this.bankOptionSelection = 2
        }
      }
    }
  }
